<template>
  <v-container
    fluid
  >
    <!---
    <v-row>
      <v-spacer></v-spacer>
      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="6"
        lg="6"
        xl="5"
      >
        <v-alert
          type="warning"
        >
          Die Terminvergabe ist beendet. Vielen Dank.
        </v-alert>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
    --->
    <v-row>
      <v-spacer></v-spacer>
      <v-col
        v-if="!booked_termin && !code"
        cols="12"
        xs="12"
        sm="12"
        md="6"
        lg="6"
        xl="5"
      >
        <v-card>
          <v-card-title>
            Größenaufnahme neue PSA
          </v-card-title>
          <v-card-subtitle>
            Es ist soweit, die neue Einsatzkleidung kommt. Bevor es losgeht, findet am 2. und 4. September 2025 die letzte Anprobe zur Aufnahme der Größen im Heinrich-Nordhoff-Ring 9 statt. Bitte buche Deinen persönlichen Termin für die Anprobe und bestätige ihn im Anschluss per E-Mail.
          </v-card-subtitle>
          <v-card-text>
            <v-form
              ref="form"
              v-model="valid"
            >
              <v-text-field
                v-model="new_termin.name"
                label="Vor- und Nachname"
                :rules="[rules.required]"
                outlined
              ></v-text-field>
              <v-text-field
                v-model="new_termin.mail"
                label="E-Mail"
                :rules="[rules.required, rules.email]"
                outlined
              ></v-text-field>
              <v-select
                v-model="new_termin.ortsfeuerwehr"
                label="Ortsfeuerwehr"
                :items="ortsfeuerwehrs"
                :rules="[rules.required]"
                outlined
              ></v-select>
            </v-form>

          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        v-if="!booked_termin && !code"
        cols="12"
        xs="12"
        sm="12"
        md="6"
        lg="6"
        xl="5"
      >
        <v-card
          :loading="!groupedAppointments"
        >
          <v-card-text>
            <v-alert v-if="groupedAppointments && Object.keys(groupedAppointments).length === 0" type="warning">Es gibt aktuell keine freien Termine mehr</v-alert>
            <v-tabs
              v-if="groupedAppointments && Object.keys(groupedAppointments).length > 0"
            >
              <v-tab
                v-for="(day, index) in groupedAppointments"
                :key="index"
              >
                {{ index }}
              </v-tab>
              <v-tab-item
                v-for="(day, index) in groupedAppointments"
                :key="index"
              >
                <v-chip-group
                  v-model="new_termin.date"
                  active-class="primary--text"
                  column
                >
                  <v-chip
                    v-for="(appointment, index) in day"
                    :key="index"
                    :value="appointment.date"
                  >
                    {{ index }}
                  </v-chip>
                </v-chip-group>
              </v-tab-item>
            </v-tabs>
            <v-alert
              v-if="error"
              type="error"
            >{{ error }}</v-alert>
            </v-card-text>
          <v-card-actions>
            <v-btn
              class="primary"
              :loading="isSubmitting"
              :disabled="!valid || !new_termin.date || isSubmitting"
              @click="submitTermin"
            >
              Termin buchen
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              class="mx-2"
              fab
              dark
              small
              @click="send_support_mail"
              color="primary"
            >
              <v-icon dark>
                mdi-chat-question
              </v-icon>
            </v-btn>
            </v-card-actions>
        </v-card>
      </v-col>
      <v-col
        v-if="booked_termin && !code"
        cols="12"
        xs="12"
        sm="12"
        md="6"
        lg="6"
        xl="5"
      >
        <v-card>
          <v-card-title class="pb-2">
            Termin reserviert
          </v-card-title>
          <v-card-text>
            <p>
              Vielen Dank, <strong>{{ booked_termin.name }}</strong>!<br>
              Dein Termin am <strong>{{ new Date(booked_termin.date).toLocaleDateString('de-DE') }}</strong>
              um <strong>{{ new Date(booked_termin.date).toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' }) }} Uhr</strong>
              wurde erfolgreich reserviert.
            </p>
            <p>
              Eine Bestätigungsmail wurde an <strong>{{ booked_termin.mail }}</strong> gesendet.<br>
              Bitte öffne die E-Mail und bestätige den Termin über den enthaltenen Link.
            </p>
            <p class="mt-4">
              Falls Du keine E-Mail erhältst, prüfe bitte auch Deinen Spam-Ordner.
            </p>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="primary"
              @click="booked_termin = null">
              Neuen Termin buchen
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col
        v-if="booked_termin && code"
        cols="12"
        xs="12"
        sm="12"
        md="6"
        lg="6"
        xl="5"
      >
        <v-card>
          <v-card-title class="pb-2">
            Termin bestätigt
          </v-card-title>
          <v-card-text>
            Der Termin für <strong>{{ booked_termin.name }}</strong> wurde erfolgreich bestätigt.
            <v-list dense>
              <v-list-item dense class="mb-1 pl-0">
                <v-list-item-content class="py-1">
                  <v-list-item-title>📅 Datum:</v-list-item-title>
                  <v-list-item-subtitle>
                    {{ new Date(booked_termin.date).toLocaleDateString('de-DE') }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item dense class="mb-1 pl-0">
                <v-list-item-content class="py-1">
                  <v-list-item-title>⏰ Uhrzeit:</v-list-item-title>
                  <v-list-item-subtitle>
                    {{ new Date(booked_termin.date).toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' }) }} Uhr
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item dense class="mb-1 pl-0">
                <v-list-item-content class="py-1">
                  <v-list-item-title>🚒 Ortsfeuerwehr:</v-list-item-title>
                  <v-list-item-subtitle>{{ booked_termin.ortsfeuerwehr }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="booked_termin.comment" dense class="mb-1 pl-0">
                <v-list-item-content class="py-1">
                  <v-list-item-title>📝 Kommentar:</v-list-item-title>
                  <v-list-item-subtitle>{{ booked_termin.comment }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item dense class="mb-1 pl-0">
                <v-list-item-content class="py-1">
                  <v-list-item-title>📍 Ort:</v-list-item-title>
                  <v-list-item-subtitle>
                    <a
                      href="https://www.google.com/maps?q=Heinrich-Nordhoff-Ring+9,+30826+Garbsen"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Heinrich-Nordhoff-Ring 9, 30826 Garbsen
                    </a>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="error"
              :loading="isSubmitting"
              :disabled="!code || isSubmitting"
               @click="cancelTermin(code)"
            >
              Termin stornieren
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              @click="code = null; booked_termin = null; $router.push('/public/termine')">
              Zurück zur Übersicht
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col
        v-if="!booked_termin && code"
        cols="12"
        xs="12"
        sm="12"
        md="6"
        lg="6"
        xl="5"
      >
        <v-card
          v-if="!isSubmitting"
        >
          <v-card-title class="pb-2">
            Termin storniert
          </v-card-title>
          <v-card-text>
            Der Termin wurde erfolgreich storniert.
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="primary"
              @click="code = null; booked_termin = null; $router.push('/public/termine')">
              Zurück zur Übersicht
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
        <v-card
          v-else
          loading
        >
          <v-card-title></v-card-title>
          <v-card-text></v-card-text>
        </v-card>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "TerminView",
  data: () => ({
    new_termin: {
      date: null,
      name: null,
      mail: null,
      ortsfeuerwehr: null,
      comment: null
    },
    isSubmitting: false,
    booked_termin: null,
    code: null,
    error: null,
    ortsfeuerwehrs: [
      "Berenbostel",
      "Frielingen",
      "Garbsen",
      "Heitlingen",
      "Horst",
      "Meyenfeld",
      "Osterwald Oberende",
      "Osterwald Unterende",
      "Schloß Ricklingen",
      "Stelingen",
    ],
    rules: {
      required: v => !!v || 'Dieses Feld ist erforderlich',
      email: v => /.+@.+\..+/.test(v) || 'Ungültige E-Mail-Adresse'
    },
    valid: true
  }),
  methods: {
    appointments_free_update(){
      this.$store.dispatch("update", { "context": "/appointments/free" })
    },
    confirmTermin(code) {
      if (!code) return;
      this.isSubmitting = true
      const query = this.$store.state.general.api_host + '/appointments/' + code;
      fetch(query, {
        method: 'PUT'
      })
        .then(async response => {
          const contentType = response.headers.get("content-type");
          const isJson = contentType && contentType.includes("application/json");
          if (response.status === 200) {
            return response.json()
          }
          else if(response.status === 404){
            console.log(response)
            return null
          }
          else {
            const errorData = isJson ? await response.json() : {};
            const errorMessage = errorData.detail || response.statusText || "Unbekannter Fehler";
            throw new Error(errorMessage);
          }
        })
        .then(data => {
          this.booked_termin = data
          this.error = null;
        })
        .catch(error => {
          this.error = error.message;
          console.error('Fehler bei der Bestätigung:', error);
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
    cancelTermin(code) {
      if (!code) return;
      this.isSubmitting = true
      const query = this.$store.state.general.api_host + '/appointments/' + code;
      fetch(query, {
        method: 'DELETE'
      })
        .then(async response => {
          const contentType = response.headers.get("content-type");
          const isJson = contentType && contentType.includes("application/json");
          if (response.status === 200) {
            return response.json()
          } else {
            const errorData = isJson ? await response.json() : {};
            const errorMessage = errorData.detail || response.statusText || "Unbekannter Fehler";
            throw new Error(errorMessage);
          }
        })
        .then(() => {
          this.booked_termin = null;
          this.error = null;
          this.new_termin.date = null;
          this.appointments_free_update();
        })
        .catch(error => {
          this.error = error.message;
          console.error('Fehler bei der Stornierung:', error);
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
    submitTermin() {
      if (this.$refs.form.validate() && this.new_termin.date) {
        this.isSubmitting = true;
        const payload = {
          date: this.new_termin.date,
          name: this.new_termin.name,
          mail: this.new_termin.mail,
          ortsfeuerwehr: this.new_termin.ortsfeuerwehr,
          comment: this.new_termin.comment
        }
        const query = this.$store.state.general.api_host + '/appointments'
        fetch(query, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        })
          .then(async response => {
            const contentType = response.headers.get("content-type");
            const isJson = contentType && contentType.includes("application/json");
            if (response.status === 200) {
              return response.json()
            } else {
              const errorData = isJson ? await response.json() : {};
              const errorMessage = errorData.detail || response.statusText || "Unbekannter Fehler";
              throw new Error(errorMessage);
            }
          })
          .then(data => {
            this.booked_termin = data
            this.error = null;
            this.appointments_free_update()
          })
          .catch(error => {
            this.booked_termin = null;
            this.appointments_free_update();
            this.new_termin.date = null;
            this.error = error.message;
            console.error('Fehler bei der Buchung:', error);
          })
          .finally(() => {
            this.isSubmitting = false;
          });
      } else {
        console.warn("Validierung fehlgeschlagen");
      }
    },
    send_support_mail(){
      const email = "it@stadtfeuerwehr-garbsen.de";
      const subject = "Frage";
      const body = "Hallo zusammen,\r\n\r\nich habe folgende Frage:";
      const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
      window.location.href = mailtoLink; // Öffnet das E-Mail-Programm
    }
  },
  computed: {
    groupedAppointments() {
      const appointments = this.$store.state.appointments.free;
      if (!appointments) {
        return null;
      }

      const grouped = {};
      appointments.forEach(appt => {
        const date = new Date(appt.date);
        const dayKey = date.toLocaleDateString('de-DE'); // e.g. "22.08.2025"
        const timeKey = date.toLocaleTimeString('de-DE', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        }); // e.g. "14:30"

        if (!grouped[dayKey]) {
          grouped[dayKey] = [];
        }
        grouped[dayKey].push({
          timeKey,
          appt
        });
      });

      // Sortiere die Tage chronologisch
      const sortedGrouped = {};
      Object.keys(grouped)
        .sort((a, b) => {
          const [dayA, monthA, yearA] = a.split('.').map(Number);
          const [dayB, monthB, yearB] = b.split('.').map(Number);
          return new Date(yearA, monthA - 1, dayA) - new Date(yearB, monthB - 1, dayB);
        })
        .forEach(dayKey => {
          grouped[dayKey].sort((a, b) => {
            const [hourA, minuteA] = a.timeKey.split(':').map(Number);
            const [hourB, minuteB] = b.timeKey.split(':').map(Number);
            return hourA * 60 + minuteA - (hourB * 60 + minuteB);
          });
          // Wandle zurück in das Objektformat, das du im Template verwendest
          const timeObj = {};
          grouped[dayKey].forEach(entry => {
            timeObj[entry.timeKey] = entry.appt;
          });
          sortedGrouped[dayKey] = timeObj;
        });

      return sortedGrouped;
    }
  },
  mounted() {
    this.appointments_free_update()
    const code = this.$route.params.code;

    if(code){
      this.code = code
      this.confirmTermin(code)
    }
  },
};
</script>

<style scoped>

</style>
